<template>
  <div>
    <p style="margin: 14px 0">
      <text-with-mark :text="$t('问法')" />
    </p>
    <t-table
      class="no-border-table"
      :data="formData.intentions"
      row-key="id"
      drag-sort="row-handler"
      lazy-load
      size="small"
      :columns="columns"
      vertical-align="top"
      :show-header="false"
      @dragSort="onDragSort"
    >
      <template #intention="{ rowIndex }">
        <t-form-item
          :name="`intentions[${rowIndex}]`"
          :rules="requireRule"
          :required-mark="false"
        >
          <t-space :size="8">
            <t-input
              v-model="formData.intentions[rowIndex].q"
              maxlength="200"
              style="width: 385px"
            />
            <CloseCircleIcon
              size="16"
              style="cursor: pointer; vertical-align: bottom"
              @click="deleteIntentions(rowIndex)"
            />
          </t-space>
        </t-form-item>
      </template>
      <template #bottomContent>
        <t-form-item
          name="intentions"
          :rules="intentionsRules"
          :status-icon="false"
        >
          <div v-if="formData.intentions.length < 20">
            <t-link theme="primary" hover="color" @click="addIntentions">{{
              $t("添加问法")
            }}</t-link>
          </div>
        </t-form-item>
      </template>
    </t-table>
  </div>

  <t-divider style="margin: 8px 0"></t-divider>
  <t-form-item :label="$t('补充描述')" name="desc">
    <t-textarea
      v-model="formData.desc"
      :autosize="{ minRows: 3 }"
      maxlength="1000"
      :placeholder="
        $t(
          '请描述希望节点触发的场景，例如：识别到用户想要退款的时候触发，如只是询问退款政策，不要触发。',
        )
      "
    />
  </t-form-item>
</template>

<script lang="ts" setup>
import { reactive, watch } from "vue";
import { CloseCircleIcon, MoveIcon } from "tdesign-icons-vue-next";
import { toString, map, merge, cloneDeep, compact, trim } from "lodash-es";
import { t } from "@/utils/i18n";

const emit = defineEmits(["updateData"]);

const intentionsRules = [
  {
    validator: (intentions) => {
      const _arr = compact(intentions);
      if (new Set(_arr).size !== _arr.length) {
        return false;
      }
      return true;
    },
    message: "问法不能重复",
    trigger: "change",
  },
];

type Model = {
  nodeData: {
    intentions: Array<string>;
    desc: string;
  };
};

const props = defineProps<{
  data: Model["nodeData"];
}>();

const formData = reactive<{
  intentions: Array<{ id: string; q: string }>;
  desc: string;
}>({
  intentions: map(props.data.intentions, (v) => ({
    id: toString(Math.random()),
    q: v,
  })) ?? [
    {
      id: toString(Math.random()),
      q: "",
    },
  ],
  desc: props.data.desc ?? "",
});

const onDragSort = (params) => {
  formData.intentions = cloneDeep(params.currentData);
};

const requireRule = [
  {
    validator: (str) => {
      return !!trim(str);
    },
    message: t("不能为空"),
    trigger: "change",
  },
];

const columns = [
  //{
  //  colKey: "drag", // 列拖拽排序必要参数
  // cell: (h) => (
  //    <span>
  //      <MoveIcon />
  //    </span>
  //  ),
  //  width: 20,
  //},
  {
    colKey: "intention",
  },
];

const addIntentions = () => {
  formData.intentions.push({
    id: toString(Math.random()),
    q: "",
  });
};

const deleteIntentions = (index: number) => {
  if (formData.intentions.length <= 1) {
    return;
  }
  formData.intentions.splice(index, 1);
};

watch(
  formData,
  (newVal) => {
    emit(
      "updateData",
      merge({}, newVal, { intentions: map(newVal.intentions, "q") }),
    );
  },
  { deep: true },
);
</script>
<style lang="less" scoped>
:deep(.flow-t-table td) {
  border: none;
}
:deep(.flow-t-table.flow-t-size-s td) {
  padding: 0px;
}
:deep(.flow-t-table tr) {
  height: 52px;
}
</style>
